import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
export const defaultItemModalDisplayText = {
    quantityCounterLabel: 'Quantity',
    addToOrderButtonLabel: 'Add to cart ${total}',
    totalSavingsLabel: 'You save ${total}'
};
export const itemModalDisplayTextValidatorSchema = {
    quantityCounterLabel: nonEmptyStringValidator,
    addToOrderButtonLabel: nonEmptyStringValidator,
    totalSavingsLabel: nonEmptyStringValidator
};
